export default __webpack_public_path__ + "static/Plots0110-419a047a3815f12ed38589f831af8eba.jpg";